module.exports = __webpack_public_path__ + "static/media/truck-grey-icon.61f043b3.svg";